import React, {useEffect, useRef} from 'react';
import * as S from './style';

const Map = ({
	lat = 34.938389596611195,
	lng = 127.51940204456996,
	content = '순천팔마종합운동장 (전라남도 순천시 팔마로 333)',
}) => {
	const mapElement = useRef(null);

	useEffect(() => {
		const { kakao } = window;
		if (!mapElement.current || !kakao) return;

		const location = new kakao.maps.LatLng(lat, lng);
		const mapOptions = {
			center: location,
			level: 3, // 네이버 zoom:17 ≈ 카카오 level:3
		};
		const map = new kakao.maps.Map(mapElement.current, mapOptions);

		const marker = new kakao.maps.Marker({
			position: location,
			title: content,
			map,
		});

		const overlay = new kakao.maps.CustomOverlay({
			position: location,
			content: `
				<div style="
					position: relative;
					background: white;
					border: 1px solid #ccc;
					border-radius: 6px;
					padding: 6px 10px;
					font-size: 15px;
					font-weight: 500;
					color: #333;
					white-space: nowrap;
					box-shadow: 0 2px 6px rgba(0,0,0,0.2);
					margin-bottom: 45px;
				">
					${content}
					<div style="
						position: absolute;
						bottom: -8px;
						left: 50%;
						transform: translateX(-50%);
						width: 0;
						height: 0;
						border-left: 8px solid transparent;
						border-right: 8px solid transparent;
						border-top: 8px solid white;
						filter: drop-shadow(0 2px 1px rgba(0,0,0,0.15));
					"></div>
				</div>
			`,
			yAnchor: 1.0,
		});

		overlay.setMap(map);

		kakao.maps.event.addListener(marker, 'click', () => {
			if (overlay.getMap()) {
				overlay.setMap(null);
			} else {
				overlay.setMap(map);
			}
		});
	}, []);

	return <S.Container ref={mapElement} />;
};

export default Map;
